var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownloadSuccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "downloader__image",
    viewBox: "304 227 171 171",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d4d7d9",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.104 251.896c33.195 33.194 33.195 87.014 0 120.208-33.194 33.195-87.014 33.195-120.208 0-33.195-33.194-33.195-87.014 0-120.208 33.194-33.195 87.014-33.195 120.208 0zm-7.07 113.137c-29.29 29.29-76.778 29.29-106.067 0-29.29-29.29-29.29-76.777 0-106.066 29.29-29.29 76.777-29.29 106.066 0 29.29 29.29 29.29 76.777 0 106.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.686 337.237c2.716 2.672 7.186 2.25 9.353-.882l28.87-41.735c1.928-2.786 1.23-6.605-1.557-8.53-2.788-1.927-6.61-1.23-8.537 1.556l-24.688 35.694-13.687-13.395c-2.413-2.376-6.3-2.346-8.676.067-2.378 2.414-2.348 6.296.067 8.673l18.856 18.552z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download_success.4bbf49ee.svg";
export { ForwardRef as ReactComponent };